import { HighlightingState } from "./types";

const state: HighlightingState = {
  selections: [],
  creating: false,
  initialized: false,
  activeSelectionId: null,
  filter: null,
  tooltip: {
    isShown: false,
    top: 0,
    left: 0,
  },
  commentTooltip: {
    isShown: false,
    mode: "show",
  },
};

export default state;
